/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2021
 * @format
 * @flow
 */

import React from "react";
import { Popup } from "../Popup";
import UserInactivity from "./UserInactivity";
import InactivityPopup from "./InactivityPopup";
import { DeviceType } from "../../enums";

const withUserInactivity = WrappedComponent => {
  class WithUserInactivity extends React.Component {
    inActivityRef = React.createRef();

    state = {
      popup: undefined,
    };

    getPopupContent = () => {
      const { popup } = this.state;
      if (!popup) return null;
      if (popup && popup.type === 'inactivityPopup') {
        return (
          <InactivityPopup
            showLogout={true}
            onAction={this.getInActivityAction}
            closePopup={this.resetInactivityAction}
          />
        );
      }
    };

    showInactivityPopup = () => {
      this.setState({ popup: { type: 'inactivityPopup' } });
    };

    getInActivityAction = () => {
      const { reduxProps, history } = this.props;
      history && history.push('/serverApp');
      // const { storeInfo } = reduxProps || {};
      // const { deviceTypeId } = storeInfo?.data || {}
      // if (deviceTypeId === DeviceType.PAYMENT_AUDIO_JACK) {
      //   history && history.push('/serverApp');
      // }
    };

    resetInactivityAction = () => {
      this.inActivityRef.current.resetInactivity();
      this.setState({ popup: undefined });
    };

    render() {
      const { popup } = this.state;
      return (
        <>
          <Popup visible={!!popup} popupStyle={{ width: '30%' }}>
            {this.getPopupContent()}
          </Popup>
          <UserInactivity
            active={true}
            ref={this.inActivityRef}
            inactivityTime={180000}
            onTimeOut={this.showInactivityPopup}
          >
            <WrappedComponent {...this.props} />
          </UserInactivity>
        </>
      );
    }
  };
  return WithUserInactivity;
};

export default withUserInactivity;
